import { storage } from "@workspace/mobile";
import { isBrowser } from "./environment";
import ls from "localstorage-slim";

/**
 * Wrapper for the storage service
 */
export const dmnStorage = {
  add: async (key: string, value: any) => {
    return isBrowser() ? ls.set(key, value) : await storage.add(key, value);
  },

  get: async (key: string) => {
    return isBrowser() ? ls.get(key) : await storage.get(key);
  },

  delete: async (key: string) => {
    return isBrowser() ? ls.remove(key) : await storage.delete(key);
  }
};
